<template>
    <button
        v-tooltip.bottom="'Language'"
        class="flex items-center justify-center gap-1 h-8 px-2 rounded-md text-slate-500 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800/60"
        type="button"
        @click="toggle"
    >
        <i class="pi pi-globe text-sm" />
        <span class="uppercase text-xs font-semibold">{{ appStore.locale }}</span>
    </button>

    <Popover ref="panel">
        <div class="w-44 flex flex-col">
            <button
                v-for="lang in LANGUAGES"
                :key="lang.code"
                class="flex items-center gap-2 px-2 py-1.5 rounded-md text-sm text-left hover:bg-slate-100 dark:hover:bg-slate-800/60"
                :class="lang.code === appStore.locale ? 'text-primary-500 font-semibold' : 'dark:text-slate-200'"
                type="button"
                @click="pick(lang.code)"
            >
                <span class="uppercase text-[11px] text-slate-400 w-6 shrink-0">{{ lang.code }}</span>
                <span>{{ lang.name }}</span>
            </button>
        </div>
    </Popover>
</template>

<script lang="ts" setup>
    import { Popover } from 'primevue'
    import { useTemplateRef } from 'vue'

    import { LANGUAGES } from '@/libs/i18n/languages'
    import { useAppStore } from '@/stores/app'
    import { useFetchStore } from '@/stores/fetch'

    const appStore   = useAppStore()
    const fetchStore = useFetchStore()
    const panel = useTemplateRef<InstanceType<typeof Popover>>('panel')

    const toggle = (event: Event) => panel.value?.toggle(event)

    const pick = (code: string) => {
        appStore.changeLocale(code)
        panel.value?.hide()

        // Persist as the user's own default so the choice survives re-login.
        if (appStore.isLoggedIn()) {
            if (appStore.userData) appStore.userData.language = code
            fetchStore.fetch('/me/language').put({ language: code }).json()
        }
    }
</script>
